import Big from "big.js";

interface ChartDataItem {
  [key: string]: any;
}

interface ChartResultItem {
  address?: string;
  name: string;
  value: number;
  total: number | Big;
}

export function setPercentages(
  data: ChartDataItem[],
  objList: Record<string, string>,
  key: string,
  dataKey: string = "rm"
): ChartResultItem[] {
  data.sort((a, b) => b[key] - a[key]);
  const t = data.reduce((acc: Big, r: ChartDataItem) => {
    return r[key] > 0 ? acc.add(r[key]) : acc;
  }, Big(0));
  let ret: ChartResultItem[] = [];
  let count: number = 0;
  let sum: Big = Big(0);
  data.forEach((r: ChartDataItem, i: number) => {
    if (r[key] <= 0) return;
    if (i < 3) {
      ret.push({
        address: r[dataKey],
        name: objList[r[dataKey]] || r[dataKey],
        value: Big(r[key]).div(t).times(100).toNumber(),
        total: r[key],
      });
    } else {
      sum = sum.add(r[key]);
      count += Big(r[key]).div(t).times(100).toNumber();
    }
  });
  if (count > 0) ret.push({ name: "Others", value: count, total: sum });
  return ret;
}
